import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ChargingStationDto } from '@dto/chargingStationDto';
import { ChargingStationsService } from '@services/entity/charging-stations.service';

import { latLng, marker, tileLayer, Map, icon, Layer } from 'leaflet';
import { MapService } from '../../../services/map/map.service';

@Component({
  selector: 'app-public-charge-canceled',
  templateUrl: './public-charge-canceled.component.html',
  styleUrls: ['./public-charge-canceled.component.scss']
})
export class PublicChargeCanceledComponent implements OnInit {

  public chargingStation?: ChargingStationDto
  
  private map: Map;
  public mapOptions = {
    zoom: 18,
    boxZoom: false,
    zoomControl: false,
    doubleClickZoom: false,
    dragging: false,
    layers: [
      tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        minZoom: 18,
        maxZoom: 18,
        attribution: '© OpenStreetMap',
      })
    ],
  }
  public markers : Layer [] = []
  
  constructor(
    private chargingStationsService: ChargingStationsService,
    private route: ActivatedRoute,
    private router: Router,
    private mapService: MapService,
  ) { }

  ngOnInit(): void {
    const chargingStationId = this.route.snapshot.queryParams['charging-station']
    this.chargingStationsService.getChargingStationPublicDetails(chargingStationId).subscribe(chargingStation => {
      this.chargingStation = chargingStation
      this.updateMap()
    }, error => {
      console.error(error)
    })
  }

  onMapReady(map: Map) {
    this.map = map
    this.map.invalidateSize()
    window.dispatchEvent(new Event('resize'))
  }

  updateMap() {
    const lat = this.chargingStation.lat
    const lon = this.chargingStation.lon
    if (this.map && lat && lon) {
      // this.mapService.getMapPosition(this.chargingStation.location).subscribe(result => {
        this.map.setView(latLng(parseFloat(lat), parseFloat(lon)))
        this.map.attributionControl.setPosition('topright')
        const newMarker = marker(
          [parseFloat(lat), parseFloat(lon)],
          {
            icon: icon({
              iconSize: [25, 41],
              iconAnchor: [13, 41],
              iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-orange.png',
              shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png'
            })
          }
        )
        this.map.addLayer(newMarker)
        this.map.invalidateSize();
        window.dispatchEvent(new Event('resize'));
      // }, error => {
      //   console.error(error)
      // })
    } else {
      console.warn("Charging station is undefined or has no location.")
    }
  }

  goBack() {
    window.history.back()
  }

  switchToEnglish() {
    // Preserve query parameters when switching to English version
    const queryParams = this.route.snapshot.queryParams;
    this.router.navigate(['/public-charge-canceled-en'], { queryParams });
  }
}
